module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page"
  }, [(_vm.isGM()) ? _c('div', {
    staticClass: "landing-page-edit-panel"
  }, [_c('div', {
    staticClass: "wrapper",
    class: [{
      'active': _vm.landingPanel
    }]
  }, [_c('div', {
    staticClass: "landing-page-edit-settings",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.landingPanel = !_vm.landingPanel
      }
    }
  }), _vm._v(" "), (_vm.editHistory === false) ? _c('div', [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pageMetaEdit = true
      }
    }
  }, [_vm._v("Edit page meta")]), _vm._v(" "), (_vm.pageEditMode === false) ? _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageEditSwitch()
      }
    }
  }, [_vm._v("Edit page content")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activateEditHistory()
      }
    }
  }, [_vm._v("Page edit history")])]) : _vm._e(), _vm._v(" "), (_vm.editHistory === true) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "page-versions"
    }
  }, [_vm._v("Page save history")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    attrs: {
      "searchable": false,
      "options": _vm.getPageVersionsForSelect(),
      "data-lpignore": "true",
      "id": "page-versions"
    },
    on: {
      "input": function($event) {
        return _vm.changeLandingPage($event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn-bottom"
  }, [(_vm.pageEditMode === true) ? _c('div', {
    staticClass: "action-btn action-btn-save",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateLandingPage()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btn action-btn-discard",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardPageEdit()
      }
    }
  }, [_vm._v("Discard")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.activatePage) ? _c('div', {
    ref: "informationMsg",
    staticClass: "inform-popup success",
    attrs: {
      "id": "information-message"
    }
  }, [_c('div', {
    staticClass: "inform-message-inner"
  }, [_c('div', {
    staticClass: "inform-title"
  }, [_vm._v("\n          Your account was successfully activated.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "inform-content"
  }, [_vm._v("\n          Please use the temporary credentials from your invitation email to login.\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "inform-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeCustomMsg()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.heroSection.hideSection || _vm.content.heroSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-hero"
  }, [_c('div', {
    staticClass: "landing-page-hero-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.content.heroSection.image)
    }),
    attrs: {
      "title": _vm.content.heroSection.altImage
    }
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.altImage),
      expression: "content.heroSection.altImage"
    }],
    staticClass: "landing-page-image-alt",
    attrs: {
      "type": "text",
      "placeholder": "Alt image"
    },
    domProps: {
      "value": (_vm.content.heroSection.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "altImage", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
    staticClass: "hero-upload",
    attrs: {
      "for": 'hero-image-upload'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
    attrs: {
      "type": "file",
      "id": 'hero-image-upload'
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.content.heroSection, 'image')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.hideSection),
      expression: "content.heroSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showHero"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.heroSection.hideSection) ? _vm._i(_vm.content.heroSection.hideSection, null) > -1 : (_vm.content.heroSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.heroSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.heroSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.heroSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showHero"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-section"
  }, [_c('div', {
    staticClass: "landing-page-hero"
  }, [(!_vm.pageEditMode) ? _c('h1', {
    staticClass: "landing-page-title color-1-100"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.title),
      expression: "content.heroSection.title"
    }],
    staticClass: "landing-page-title color-1-100",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "landing-page-description"
  }, [_vm._v("\n              " + _vm._s(_vm.content.heroSection.description) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.heroSection.description),
      expression: "content.heroSection.description"
    }],
    staticClass: "landing-page-description",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.heroSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.heroSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.content.heroSection.description))]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        return _vm.authenticate('top')
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus,
      'has-error': _vm.topLoginForm.isError || _vm.errors.has('TopEmail')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.email),
      expression: "topLoginForm.email"
    }],
    class: [{
      'border-1-50': _vm.topLoginForm.email !== '' || _vm.topLoginForm.emailFocus
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "data-vv-name": "TopEmail"
    },
    domProps: {
      "value": (_vm.topLoginForm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus,
      'has-error': _vm.topLoginForm.isError || _vm.errors.has('TopPassword')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('top')
      }
    }
  }), _vm._v(" "), ((_vm.topLoginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "TopPassword",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.topLoginForm.password) ? _vm._i(_vm.topLoginForm.password, null) > -1 : (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.topLoginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.topLoginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.topLoginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.topLoginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.topLoginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "TopPassword",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.topLoginForm.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.topLoginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.topLoginForm.password),
      expression: "topLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.topLoginForm.password !== '' || _vm.topLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-login-password",
      "data-vv-name": "TopPassword",
      "type": _vm.topLoginForm.passwordType
    },
    domProps: {
      "value": (_vm.topLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('top')
      },
      "focus": function($event) {
        _vm.topLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.topLoginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.topLoginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-error",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.topLoginForm.loginInProgress) ? _c('span', {
    staticClass: "login-form-error-container visually-hidden"
  }, [_vm._v("Submitting")]) : [(this.errors.has('TopEmail') || this.errors.has('TopPassword') || this.topLoginForm.loginErrorMessage) ? _c('div', {
    staticClass: "login-form-error-container"
  }, [(this.errors.has('TopEmail')) ? _c('span', [_vm._v(_vm._s(_vm.removeWordFromString('Top', this.errors.first('TopEmail'))))]) : _vm._e(), _c('br'), _vm._v(" "), (this.errors.has('TopPassword')) ? _c('span', [_vm._v(_vm._s(_vm.removeWordFromString('Top', this.errors.first('TopPassword'))))]) : _vm._e(), _c('br'), _vm._v(" "), (this.topLoginForm.loginErrorMessage) ? _c('span', [_vm._v(_vm._s(this.topLoginForm.loginErrorMessage))]) : _vm._e()]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('button', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.topLoginForm.loginInProgress
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('top')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.stepSection.hideSection || _vm.content.stepSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.stepSection.hideSection || content.stepSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-steps landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "landing-page-content background-1-100-before"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.hideSection),
      expression: "content.stepSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showStep"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.stepSection.hideSection) ? _vm._i(_vm.content.stepSection.hideSection, null) > -1 : (_vm.content.stepSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.stepSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.stepSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.stepSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showStep"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
    staticClass: "landing-page-steps-text color-2-77",
    attrs: {
      "aria-label": _vm._f("striphtml")(_vm.decodeHtml(_vm.content.stepSection.description))
    },
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.content.stepSection.description))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.stepSection.description),
      expression: "content.stepSection.description"
    }],
    staticClass: "landing-page-steps-text color-2-77",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section description",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.stepSection.description)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.stepSection, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.decodeHtml(_vm.content.stepSection.description)))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "steps",
    staticClass: "landing-page-steps-wrapper"
  }, [_vm._l((_vm.content.stepSection.steps), function(step, index) {
    return _c('div', {
      staticClass: "step-item",
      class: [{
        'step-active': _vm.stepActive === (index + 1)
      }, 'step__' + step.id]
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "step-item-content"
    }, [_vm._v("\n              " + _vm._s(step.text) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.text),
        expression: "step.text"
      }],
      staticClass: "step-item-content",
      attrs: {
        "data-gramm_editor": "false",
        "data-lpignore": "true",
        "placeholder": "Step item text",
        "rows": "1"
      },
      domProps: {
        "value": (step.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(step.text))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "step-item-image",
      style: ({
        backgroundImage: _vm.getImage(_vm.getHighImage(step))
      }),
      attrs: {
        "title": step.altImage
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.activatePopup(step)
        }
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('span', {
      staticClass: "step-item-upload"
    }) : _vm._e()])])
  }), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
    staticClass: "landing-page-steps-pagination"
  }, [_c('span', {
    staticClass: "step-item__1",
    class: [{
      'active': _vm.stepActive === 1
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 1
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__2",
    class: [{
      'active': _vm.stepActive === 2
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 2
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "step-item__3",
    class: [{
      'active': _vm.stepActive === 3
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stepActive = 3
      }
    }
  })]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.content.textSection.length) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content.textSection.length || (_vm.pageEditMode && _vm.isGM())),
      expression: "content.textSection.length || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-text-sections landing-page-wrapper-gray"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_vm._l((_vm.content.textSection), function(item, index) {
    return _c('div', {
      staticClass: "login-text-section-group"
    }, [(!_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "login-text-section-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "login-text-section-content"
    }, [(!_vm.pageEditMode) ? _c('div', {
      staticClass: "login-text-section-content__title color-1-100"
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.getDeviceType('mobile')) ? _c('div', {
      staticClass: "login-text-section-image",
      style: ({
        backgroundImage: _vm.getImage(item.image)
      }),
      attrs: {
        "title": item.altImage
      }
    }, [(_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.altImage),
        expression: "item.altImage"
      }],
      staticClass: "landing-page-image-alt",
      attrs: {
        "type": "text",
        "placeholder": "Alt image"
      },
      domProps: {
        "value": (item.altImage)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "altImage", $event.target.value)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.title),
        expression: "item.title"
      }],
      staticClass: "login-text-section-content__title color-1-100",
      attrs: {
        "data-gramm_editor": "false",
        "data-lpignore": "true",
        "placeholder": "Section title",
        "rows": "1"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "title", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('div', {
      staticClass: "login-text-section-content__description color-2-77"
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      staticClass: "login-text-section-content__description color-2-77",
      attrs: {
        "data-gramm_editor": "false",
        "data-lpignore": "true",
        "placeholder": "Section description",
        "rows": "1"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "keydown": function($event) {
          return _vm.autoSize($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('label', {
      staticClass: "login-text-section-upload",
      attrs: {
        "for": 'section-text-image-upload' + index
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('input', {
      attrs: {
        "type": "file",
        "id": 'section-text-image-upload' + index
      },
      on: {
        "change": function($event) {
          return _vm.onFileChange($event, item, 'image')
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
      staticClass: "login-text-section-remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeSection(_vm.content.textSection, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-add-section",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSection(_vm.content.textSection)
      }
    }
  }, [_vm._v("+ Add row")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.content.ctaSection.hideSection || _vm.content.ctaSection.hideSection === 'null' || (_vm.pageEditMode && _vm.isGM())),
      expression: "!content.ctaSection.hideSection || content.ctaSection.hideSection === 'null' || (pageEditMode && isGM())"
    }],
    staticClass: "landing-page-wrapper login-cta"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [(_vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "toggle-section-visibility"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.ctaSection.hideSection),
      expression: "content.ctaSection.hideSection"
    }],
    staticClass: "form-control__checkbox",
    attrs: {
      "type": "checkbox",
      "id": "showCTA"
    },
    domProps: {
      "checked": Array.isArray(_vm.content.ctaSection.hideSection) ? _vm._i(_vm.content.ctaSection.hideSection, null) > -1 : (_vm.content.ctaSection.hideSection)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.content.ctaSection.hideSection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.content.ctaSection, "hideSection", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.content.ctaSection, "hideSection", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.content.ctaSection, "hideSection", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "showCTA"
    }
  }, [_vm._v("Hide this section")])]) : _vm._e(), _vm._v(" "), (!_vm.pageEditMode) ? _c('h2', {
    staticClass: "landing-page-login-cta__head color-2-63",
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.content.ctaSection.title))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageEditMode && _vm.isGM()) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content.ctaSection.title),
      expression: "content.ctaSection.title"
    }],
    staticClass: "landing-page-login-cta__head color-2-63",
    attrs: {
      "data-gramm_editor": "false",
      "placeholder": "Section title",
      "data-lpignore": "true",
      "rows": "1"
    },
    domProps: {
      "value": (_vm.content.ctaSection.title)
    },
    on: {
      "keydown": function($event) {
        return _vm.autoSize($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.content.ctaSection, "title", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.decodeHtml(_vm.content.ctaSection.title)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-cta__form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        return _vm.authenticate('bottom')
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.bottomLoginForm.email !== '' || _vm.bottomLoginForm.emailFocus,
      'has-error': _vm.bottomLoginForm.isError || _vm.errors.has('BottomEmail')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-cta-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bottomLoginForm.email),
      expression: "bottomLoginForm.email"
    }],
    class: [{
      'border-1-50': _vm.bottomLoginForm.email !== '' || _vm.bottomLoginForm.emailFocus
    }],
    attrs: {
      "id": "landing-page-cta-login-email",
      "type": "email",
      "data-vv-name": "BottomEmail"
    },
    domProps: {
      "value": (_vm.bottomLoginForm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('bottom')
      },
      "focus": function($event) {
        _vm.bottomLoginForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.bottomLoginForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bottomLoginForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.bottomLoginForm.password !== '' || _vm.bottomLoginForm.passwordFocus,
      'has-error': _vm.bottomLoginForm.isError || _vm.errors.has('BottomPassword')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-cta-login-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('span', {
    staticClass: "landing-page-login-password-show",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showPassword('bottom')
      }
    }
  }), _vm._v(" "), ((_vm.bottomLoginForm.passwordType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bottomLoginForm.password),
      expression: "bottomLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.bottomLoginForm.password !== '' || _vm.bottomLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-cta-login-password",
      "data-vv-name": "BottomPassword",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.bottomLoginForm.password) ? _vm._i(_vm.bottomLoginForm.password, null) > -1 : (_vm.bottomLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('bottom')
      },
      "focus": function($event) {
        _vm.bottomLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.bottomLoginForm.passwordFocus = false
      },
      "change": function($event) {
        var $$a = _vm.bottomLoginForm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.bottomLoginForm, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.bottomLoginForm, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.bottomLoginForm, "password", $$c)
        }
      }
    }
  }) : ((_vm.bottomLoginForm.passwordType) === 'radio') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bottomLoginForm.password),
      expression: "bottomLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.bottomLoginForm.password !== '' || _vm.bottomLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-cta-login-password",
      "data-vv-name": "BottomPassword",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.bottomLoginForm.password, null)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('bottom')
      },
      "focus": function($event) {
        _vm.bottomLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.bottomLoginForm.passwordFocus = false
      },
      "change": function($event) {
        return _vm.$set(_vm.bottomLoginForm, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.bottomLoginForm.password),
      expression: "bottomLoginForm.password"
    }],
    class: [{
      'border-1-50': _vm.bottomLoginForm.password !== '' || _vm.bottomLoginForm.passwordFocus
    }],
    attrs: {
      "id": "landing-page-cta-login-password",
      "data-vv-name": "BottomPassword",
      "type": _vm.bottomLoginForm.passwordType
    },
    domProps: {
      "value": (_vm.bottomLoginForm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.authenticate('bottom')
      },
      "focus": function($event) {
        _vm.bottomLoginForm.passwordFocus = true
      },
      "blur": function($event) {
        _vm.bottomLoginForm.passwordFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bottomLoginForm, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-form-error",
    attrs: {
      "aria-live": "assertive"
    }
  }, [(this.bottomLoginForm.loginInProgress) ? _c('span', {
    staticClass: "login-form-error-container visually-hidden"
  }, [_vm._v("Submitting")]) : [(this.errors.has('BottomEmail') || this.errors.has('BottomPassword') || this.bottomLoginForm.loginErrorMessage) ? _c('div', {
    staticClass: "login-form-error-container"
  }, [(this.errors.has('BottomEmail')) ? _c('span', [_vm._v(_vm._s(_vm.removeWordFromString('Bottom', this.errors.first('BottomEmail'))))]) : _vm._e(), _c('br'), _vm._v(" "), (this.errors.has('BottomPassword')) ? _c('span', [_vm._v(_vm._s(_vm.removeWordFromString('Bottom', this.errors.first('BottomPassword'))))]) : _vm._e(), _c('br'), _vm._v(" "), (this.bottomLoginForm.loginErrorMessage) ? _c('span', [_vm._v(_vm._s(this.bottomLoginForm.loginErrorMessage))]) : _vm._e()]) : _vm._e()]], 2), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('button', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.bottomLoginForm.loginInProgress
    }],
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.authenticate('bottom')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "reset-password",
    attrs: {
      "to": {
        name: 'forgot-password'
      }
    }
  }, [_vm._v("Forgot password?")])], 1)])])])])]), _vm._v(" "), (_vm.activePopup && _vm.pageEditMode && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "popup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Upload icons")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (normal)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.image)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'image')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImage),
      expression: "activePopup.altImage"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-item"
  }, [_c('h2', [_vm._v("Image (high contrast)")]), _vm._v(" "), _c('div', {
    staticClass: "modal-image",
    style: ({
      backgroundImage: _vm.getImage(_vm.activePopup.imageHigh)
    })
  }, [_c('label', {
    staticClass: "step-item-upload",
    attrs: {
      "for": "popup-step-high-image-upload"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "popup-step-high-image-upload"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange($event, _vm.activePopup, 'imageHigh')
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activePopup.altImageHigh),
      expression: "activePopup.altImageHigh"
    }],
    attrs: {
      "type": "text",
      "placeholder": "High contrast image alt"
    },
    domProps: {
      "value": (_vm.activePopup.altImageHigh)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activePopup, "altImageHigh", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.pageMetaEdit && _vm.isGM()) ? _c('div', {
    staticClass: "landing-page-change-image"
  }, [_c('div', {
    ref: "metaEditPopup",
    staticClass: "modal-inner"
  }, [_c('h1', [_vm._v("Change page meta")]), _vm._v(" "), _c('a', {
    staticClass: "modal-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-footer-edit"
  }, [_c('div', [_c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.title),
      expression: "metaData.title"
    }],
    attrs: {
      "id": "meta-title",
      "placeholder": "Page meta title"
    },
    domProps: {
      "value": (_vm.metaData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta-description"
  }, [_c('label', {
    attrs: {
      "for": "meta-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metaData.description),
      expression: "metaData.description"
    }],
    attrs: {
      "id": "meta-description",
      "placeholder": "Page meta description"
    },
    domProps: {
      "value": (_vm.metaData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.metaData, "description", $event.target.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.metaData.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "popup-actions"
  }, [_c('a', {
    staticClass: "discard",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup()
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('a', {
    staticClass: "submit",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateMeta()
      }
    }
  }, [_vm._v("Save")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-669ebdc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Login.vue
// module id = 953
// module chunks = 1